module.exports = __webpack_public_path__ + "static/value_bg-70596bb286f0a084596d1ccf0916d3dc.png";